import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const getOfferCategory = () => {
  return axios({
    method: 'get',
    url: STORE_BASE_URL + '/store/api/secure/v1/offer/offer-category',
    headers: getHeaders(),
  });
};

export const getOfferType = () => {
  return axios({
    method: 'get',
    url: STORE_BASE_URL + '/store/api/secure/v1/offer/offer-type',
    headers: getHeaders(),
  });
};

export const addBrandOffer = (brandId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/offer/brand/' +
      brandId +
      '/brand-offer',
    // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateBrandOffer = (brandId, data) => {
  return axios({
    method: 'put',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/offer/brand/' +
      brandId +
      '/brand-offer',
    // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getBrandOffer = brandId => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/offer/brand/' +
      brandId +
      '/brand-offer',
    headers: getHeaders(),
  });
};

export const getBrandOfferItem = (brandId, itemId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/offer/brand/' +
      brandId +
      '/brand-offer/' +
      itemId +
      '/item',
    headers: getHeaders(),
  });
};


export const getBrandSingleOffer = (brandId, offerId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/offer/brand/' +
      brandId +
      '/brand-offer/' +
      offerId,
    headers: getHeaders(),
  });
};